<template>
  <v-container fluid>
    <a-form layout="vertical">
      <a-row :gutter="8">
        <a-col :span="24" :xxl="4" :xl="6" :lg="8" :md="12">
          <a-form-item label="交易日期">
            <a-range-picker v-model="queryForm.day_range" :mode="['date', 'date']" :placeholder="['开始日期', '结束日期']"
              :locale="locale" :allowClear="false" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" style="width:100%;" />
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-item label="车牌号">
            <a-input v-model="queryForm.vehicle_number" placeholder="车牌号" style="width:100%;"
              @keyup.enter="getdata()" />
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="3" :xl="3" :lg="4" :md="6">
          <a-form-item label="上站信息">
            <a-input v-model="queryForm.onstation" placeholder="上站信息" style="width:100%;" @keyup.enter="getdata()" />
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="3" :xl="3" :lg="4" :md="6">
          <a-form-item label="下站信息">
            <a-input v-model="queryForm.offstation" placeholder="下站信息" style="width:100%;" @keyup.enter="getdata()" />
          </a-form-item>
        </a-col>
        <!-- <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-item label="状态">
            <a-select v-model="queryForm.match_state" :options="[
              { label: '未匹配', value: 0 },
              { label: '已匹配', value: 1 },
            ]" :allowClear="true" placeholder="请选择" style="width:100%;">
            </a-select>
          </a-form-item>
        </a-col> -->
        <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-item label=".">
            <a-space>
              <a-button @click="getdata()" type="primary">
                查询
              </a-button>
              <a-button @click="() => $refs.uploadRef.showupload()" class="btn-cyan">
                <a-icon type="upload" />上传记录
              </a-button>
              <a-button @click="download" class="btn-success">
                <a-icon type="download" />下载记录
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-tabs v-model="queryForm.match_state" size="small" @change="getdata()">
      <a-tab-pane :key="0" tab="未匹配"></a-tab-pane>
      <a-tab-pane :key="1" tab="已匹配"></a-tab-pane>
    </a-tabs>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="summaryList" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="vehicle_number" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="trade_amount" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="pay_channel_fee" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="create_time" slot-scope="text, record">
          {{ record._isSummary ? '' : record.create_time | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template slot="match_state" slot-scope="text, record">
          <template v-if="!record._isSummary">
            <p :class="{
              'success--text': record.match_state === 1,
              'error--text': record.match_state !== 1,
            }">{{ record.match_state === 1 ? '已匹配' : '未匹配' }}</p>
            <p v-if="record.bill">{{ record.bill.postroute }}</p>
            <p v-if="record.bill">{{ record.bill.dispatch_no }}</p>
            <v-btn v-if="record.match_state === 1 && username === 'root'" class="error--text" tile text small
              @click="resetmatch(record._id)">重新匹配</v-btn>
          </template>
        </template>
        <!-- <template slot="action" slot-scope="text, record">
          <a-space>
            <a-popconfirm title="删除ETC消费记录" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template> -->
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <UploadTask ref="uploadRef" modelTitle="上传ETC消费记录"
      :alertText="`上传Excel文件需包含 <span class='error--text'>车牌号</span>、<span class='error--text'>交易时间</span>、<span class='error--text'>ETC卡号</span>、<span class='error--text'>交易金额</span>、<span class='error--text'>上站信息</span>、<span class='error--text'>下站信息</span>字段。`"
      uploadType="etcbill" :templateFile="templateFile" />
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
import UploadTask from "@/components/uploadtask.vue";
export default {
  name: "EtcList",
  data() {
    return {
      locale,
      queryForm: {
        day_range: [],
        vehicle_number: "",
        onstation: "",
        offstation: "",
        match_state: 0,
      },
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      headers: [
        // { title: "订单号", dataIndex: "order_number", scopedSlots: { customRender: "order_number" }, width: 150, align: "center" },
        { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 120, align: "center" },
        { title: "状态", dataIndex: "match_state", scopedSlots: { customRender: "match_state" }, width: 120, align: "center" },
        // { title: "车辆类型", dataIndex: "vehicle_type", scopedSlots: { customRender: "vehicle_type" }, width: 120, align: "center" },
        { title: "车牌颜色", dataIndex: "vehicle_platecolor", scopedSlots: { customRender: "vehicle_platecolor" }, width: 120, align: "center" },
        { title: "交易时间", dataIndex: "trade_time", scopedSlots: { customRender: "trade_time" }, width: 120, align: "center" },//套牌号
        { title: "ETC卡号", dataIndex: "card_no", scopedSlots: { customRender: "card_no" }, width: 120, align: "center" },
        { title: "OBU编号", dataIndex: "obu_no", scopedSlots: { customRender: "obu_no" }, width: 120, align: "center" },
        { title: "交易金额(元)", dataIndex: "trade_amount", scopedSlots: { customRender: "trade_amount" }, width: 120, align: "center" },//元/月,包车费/月租,自动关联过来,临时车在调度计划里填写然后关联到路单和财务账单
        { title: "支付通道费(元)", dataIndex: "pay_channel_fee", scopedSlots: { customRender: "pay_channel_fee" }, width: 120, align: "center" },
        { title: "上站信息", dataIndex: "onstation", scopedSlots: { customRender: "onstation" }, width: 180, align: "center" },
        { title: "下站信息", dataIndex: "offstation", scopedSlots: { customRender: "offstation" }, width: 120, align: "center" },
        { title: "交易描述", dataIndex: "trade_desc", scopedSlots: { customRender: "trade_desc" }, width: 120, align: "center" },
        { title: "上传时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 180, align: "center" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      templateFile: {
        url: `${process.env.BASE_URL}template/ETC交易记录导入模板.xlsx`,
        name: 'ETC交易记录导入模板.xlsx',
      },
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    summaryList() {
      if (!this.list || this.list.length === 0) return [];
      const total = this.list.reduce((acc, row) => ({
        trade_amount: acc.trade_amount + (Number(row.trade_amount) || 0),
        pay_channel_fee: acc.pay_channel_fee + (Number(row.pay_channel_fee) || 0),
      }), { trade_amount: 0, pay_channel_fee: 0 });
      return [
        {
          _id: 'summary',
          _isSummary: true,
          vehicle_number: '合计',
          trade_amount: total.trade_amount.toFixed(2),
          pay_channel_fee: total.pay_channel_fee.toFixed(2),
        },
        ...this.list,
      ];
    },
  },
  components: { UploadTask },
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 350;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 350;
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
    let start_day = this.$moment().startOf('month').format('YYYY-MM-DD');
    let end_day = this.$moment().endOf('month').format('YYYY-MM-DD');
    this.queryForm = {
      day_range: [start_day, end_day],
      vehicle_number: "",
      onstation: "",
      offstation: "",
      match_state: 0,
    };
  },
  activated() {
    this.getdata();
  },
  methods: {
    download() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/etcbill/list", { page: this.page, limit: this.limit, ...this.queryForm, action: "download" }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$download(res.data.url, res.data.name);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/etcbill/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/etcbill/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    resetmatch(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/etcbill/resetmatch", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 0;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
